import { ConfirmModal } from 'components/ModalViewV3';

const CallInProgressModal = ({
  isCallInProgressModalOpen,
  setIsCallInProgressModalOpen,
}: {
  isCallInProgressModalOpen: boolean;
  setIsCallInProgressModalOpen: (open: boolean) => void;
}) => {
  return (
    <ConfirmModal
      showCloseIcon
      title="Call In Progress"
      description="Please end the call and complete the disposition to continue."
      open={isCallInProgressModalOpen}
      onOutsideClick={() => setIsCallInProgressModalOpen(false)}
      onDismiss={() => setIsCallInProgressModalOpen(false)}
      onCancel={() => setIsCallInProgressModalOpen(false)}
      onConfirm={() => setIsCallInProgressModalOpen(false)}
      variant="success"
      icon="phone-call-01"
    />
  );
};

export default CallInProgressModal;
